import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const THEME_STORAGE_KEY = "theme";
const DEFAULT_THEME = "light";

function normalizeTheme(theme) {
  return theme === "dark" ? "dark" : DEFAULT_THEME;
}

function applyTheme(theme) {
  const root = document.documentElement;
  const isDark = theme === "dark";

  root.classList.toggle("dark", isDark);
  root.style.colorScheme = isDark ? "dark" : "light";

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute("content", isDark ? "#0f172a" : "#f8fafc");
  }
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(
    () => normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY))
  );

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = (nextTheme) => {
    setThemeState((currentTheme) => {
      const resolvedTheme =
        typeof nextTheme === "function" ? nextTheme(currentTheme) : nextTheme;
      return normalizeTheme(resolvedTheme);
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
